import React, { useState } from "react";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import logo from "../assets/logo.png";
import { useDispatch } from "react-redux";
import { setUser } from "../store/slices/userSlice.js";
import { extractRolesFromToken } from "../utils/extractRolesFromToken.js";
import { useNavigate } from "react-router-dom";
import { AUTH_API } from "../api/apiroutes.js";

const Login = () => {
  const [logoRotate, setLogoRotate] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  console.log("printing client id ,", process.env.REACT_APP_GOOGLE_CLIENT_ID);
  const handleSuccess = async (credentialResponse) => {
    try {
      const idToken = credentialResponse?.credential;
      if (!idToken) {
        toast.error("No ID token received from Google");
        return;
      }

      const res = await axios.post(AUTH_API.LOGIN, { idToken });
      console.log(AUTH_API.LOGIN);
      console.log("dvd", res.data);
      // ✅ Correct destructuring
      const { accessToken, user } = res.data.data;

      // ✅ Persist token (optional but useful)
      localStorage.setItem("token", accessToken);

      // ✅ Extract roles from JWT
      const roles = extractRolesFromToken(accessToken);
      console.log(roles);

      // ✅ Store EVERYTHING in Redux
      dispatch(
        setUser({
          user, // private profile data
          roles, // ["user", "admin"]
          token: accessToken,
        }),
      );
      localStorage.setItem(
        "auth",
        JSON.stringify({
          user,
          token: accessToken,
        }),
      );
       if (roles.includes("admin")) {
        toast.success("Admin login successful! Redirecting...");
      } else if (roles.includes("user")) {
        toast.success("User login successful! Redirecting...");
      } else if (roles.length === 1 && roles.includes("subscriber")) {
        toast.error("You have not permitted to access the dashboard. Please Contact Admin.");
      } else {
        toast.error("No valid role assigned.");
      }

       if (roles.includes("admin")) {
          navigate("/admin/dash/insights");
        } else {
          navigate("/admin/dash/insights");
        }
      // setTimeout(() => {
      //   if (roles.includes("admin")) {
      //     navigate("/admin/dash/insights");
      //   } else {
      //     navigate("/admin/dash/insights");
      //   }
      // }, 10);

     
    } catch (err) {
      console.error(err);
      toast.error(
        err.response?.data?.message ||
          err.message ||
          "Login failed. Please try again",
      );
    }
  };

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <div className="min-h-screen flex items-center justify-center bg-gray">
        <div className="w-full max-w-md bg-[#FF8C42]/90 backdrop-blur rounded-2xl shadow-2xl p-8 animate-fade-in">
          {/* Logo */}
          <div className="flex justify-center mb-4">
            <img
              src={logo}
              alt="SmartZman Logo"
              className={`h-16 w-auto transition-transform duration-700 ${
                logoRotate ? "rotate-[360deg]" : "rotate-0"
              }`}
            />
          </div>

          {/* Title */}
          <div className="text-center mb-6">
            <h1 className="text-2xl font-bold text-white">SmartZman</h1>
            <p className="text-white/90 mt-1">Login</p>
          </div>

          {/* Google Login */}
          <div className="flex justify-center">
            <div
              onMouseEnter={() => setLogoRotate(true)}
              onMouseLeave={() => setLogoRotate(false)}
            >
              <GoogleLogin
                onSuccess={handleSuccess}
                onError={() => toast.error("Google login failed")}
                useOneTap
              />
            </div>
          </div>

          {/* Footer */}
          <p className="text-xs text-center text-white/80 mt-6">
            Need help?{" "}
            <a
              href="mailto:support@smartzman.com"
              className="underline hover:text-white font-semibold"
            >
              Click here for support
            </a>
          </p>
        </div>
      </div>
    </GoogleOAuthProvider>
  );
};


export default Login;
